// extracted by mini-css-extract-plugin
export default {"goBack":"go-back-view_goBack__9E-s8"};